/**
 * 服务费账户
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XInput, XOKButton, XCancelButton, XSelect } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import TableList from './components/TableList';
import model from '@/reducers/finance/accountflow/model';
import KeepAlive from '@/routes/KeepAlive';
import { SearchBox, SearchItem } from '@/components/Layout';
import { autoPageNum, autopageSize } from '@/assets/config';
import { getLocalStorage } from '@/assets/js/storage';

class Main extends React.Component {

    state = {
        recordNo: '',
        relationNo: '',
        incomeDrawType: {},
        changeSource: {},
        outUserId: (getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : {}).loginUserId,
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.getIncomeDrawTypeList({ enumName: 'BizLoanType' });
        this.props.getChangeSourceTypeList({ enumName: 'ChangeCostSettingEnum' });
    }

    // 查询
    _searchHandle = (useCache) => {
        const { recordNo, relationNo, changeSource, incomeDrawType, outUserId, pageNum, pageSize } = this.state;
        this.searchCache = {
            id: recordNo,
            extraBiz: relationNo,
            loanType: incomeDrawType.code,
            appChangeType: changeSource.code,
            outUserType: this.props.curTabID,
            outUserId,
            accountType: 'MONEY',
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getAccountList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置
    _resetHandle = () => {
        this.setState({ recordNo: '', relationNo: '', changeSource: {}, incomeDrawType: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }

    render() {
        const { recordNo, relationNo, changeSource, incomeDrawType } = this.state;
        const { accountList, incomeDrawTypeList, changeSourceTypeList } = this.props;
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='记录流水号'
                                placeholder='请输入'
                                value={recordNo}
                                bindThis={this}
                                bindName='recordNo'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '200px' }}
                                label='关联单号'
                                placeholder='请输入'
                                value={relationNo}
                                bindThis={this}
                                bindName='relationNo'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '200px' }}
                                label='收支类型'
                                placeholder='请选择'
                                renderData={incomeDrawTypeList}
                                dataIndex='value'
                                keyIndex='code'
                                value={incomeDrawType.value}
                                bindThis={this}
                                bindName='incomeDrawType'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '200px' }}
                                label='变动来源'
                                placeholder='请选择'
                                renderData={changeSourceTypeList}
                                dataIndex='value'
                                keyIndex='code'
                                value={changeSource.value}
                                bindThis={this}
                                bindName='changeSource'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList renderData={accountList} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getAccountList: PropTypes.func,
    accountList: PropTypes.object,

    getIncomeDrawTypeList: PropTypes.func,
    incomeDrawTypeList: PropTypes.array,

    getChangeSourceTypeList: PropTypes.func,
    changeSourceTypeList: PropTypes.array,
};
const mapStateToProps = (state) => ({
    incomeDrawTypeList: state.accountflow.incomeDrawTypeList,
    changeSourceTypeList: state.accountflow.changeSourceTypeList,
    accountList: state.accountflow.accountList,
});

export default connect(mapStateToProps, { ...model.actions })(Main);